export default "/images/6.png?7b15aa5f41a6ef3eaba9e47dcac39572";